import React, { useContext, useState } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  notification,
  Space,
  Typography,
} from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "../Login.css";
// import Background_login from '../../../images/realestate-back.jpeg';
import Logo from "../../../theme/images/logo_oseo_valais_retina.png";
import back from "../../../theme/images/back.jpeg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { UserContext } from "../../../engine/context/User.context";
import CustomForm from "../../../shared/components/CustomForm";
import { getLogoByCustomer } from "../../../engine/customerConfig";
import LanguageSelector from "../../../shared/components/LanguageSelector";
import { useTranslation } from "react-i18next";

export const Login = () => {
  const { t } = useTranslation();

  const { logUser, configuration } = useContext(UserContext);
  const navigate = useNavigate();

  const onFinish = async values => {
    values.username = values.username.toLowerCase();

    const log = await logUser(values.username, values.password);

    if (log) {
      navigate("/");
    }
  };

  const onFinishFailed = errorInfo => {
    notification.error({
      message: errorInfo.errorFields.length + ` ${t("Login.errors")}`,
    });
  };

  return (
    <div className={"login-back"} style={{ backgroundImage: `url(${back})` }}>
      <div className={"login-container"}>
        <Card bodyStyle={{}} style={{ padding: 20 }}>
          <LanguageSelector lang={"fr"} />
          <img src={getLogoByCustomer()} className={"login-logo"} />
          <br />
          <Typography.Title
            level={3}
            className={""}
            style={{ textAlign: "center" }}
          >
            {t("Login.welcome")}
          </Typography.Title>
          <Form
            onFinishFailed={onFinishFailed}
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            style={{ width: "calc(100% - 20px)" }}
            onFinish={onFinish}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: t("Login.errorMessageUser"),
                },
                {
                  type: "email",
                  message: t("Login.errorMessageEmail"),
                },
              ]}
              normalize={value => value && value.toLowerCase()}
            >
              <Input
                addonBefore={
                  <UserOutlined
                    className="site-form-item-icon"
                    style={{ margin: 3 }}
                  />
                }
                size={"large"}
                placeholder="Email"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: t("Login.errorMessage"),
                },
              ]}
            >
              <Input.Password
                iconRender={visible =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                size={"large"}
                addonBefore={
                  <LockOutlined
                    className="site-form-item-icon"
                    style={{ margin: 3 }}
                  />
                }
                type="password"
                placeholder={t("Login.password")}
              />
            </Form.Item>
            <br />
            <Form.Item>
              <Button
                style={{ width: "100%", marginBottom: "10px" }}
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                {t("Login.login")}
              </Button>
              {/*<Button*/}
              {/*  style={{ width: "calc(50% - 10px)" }}*/}
              {/*  onClick={() => navigate("/auth/register")}*/}
              {/*  className="login-form-button"*/}
              {/*>*/}
              {/*  S'inscrire*/}
              {/*</Button>*/}
              <Space
                style={{ justifyContent: "space-between", display: "flex" }}
              >
                <Link className="login-form-forgot" to="/auth/lost">
                  {t("Login.forgotPassword")}
                </Link>
                <a
                  href={`mailto:${configuration?.common?.emailSupport}`}
                  style={{ width: "calc(50%)", marginLeft: "10px" }}
                >
                  {t("Login.needHelp")}
                </a>
              </Space>
            </Form.Item>
          </Form>
          <cite
            style={{
              textAlign: "center",
              width: "100%",
            }}
          >
            {process.env.CUSTOMER_ID}
          </cite>
        </Card>
      </div>
    </div>
  );
};
